(function () {
    'use strict';

    angular
        .module('followUpModule')
        .controller('FollowUpFullController', Controller);

    Controller.$inject = ['$scope', '$rootScope', 'attachmentService', '$timeout'];

    function Controller($scope, $rootScope, attachmentService, $timeout) {

        // Page is dirty
        $scope.ctxtCtrl = {};
        $scope.ctxtCtrl.needSaveChanges = false;

        $scope.pageIsDirty = function () {
            $scope.ctxtCtrl.needSaveChanges = true;
            $rootScope.$broadcast('page-is-dirty');
        }
        $scope.pageIsNotDirty = function () {
            $scope.ctxtCtrl.needSaveChanges = false;
            $rootScope.$broadcast('page-is-not-dirty');
        }

        // ACTIONS

        $scope.showActions = function () {
            return $scope.ctxtCtrl.needSaveChanges;
        };

        $scope.submitFollowUp = function () {
            $scope.loading = true;
            return $scope
                    .submit()($scope.boxModel)
                    .then(function (result) {
                        resetFollowUp();
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
        };

        $scope.discardChanges = function () {
            resetFollowUp();
        };

        // Upload attachments
        $scope.uploadAttachments = function (files, events) {
            if (_.isUndefined($scope.boxModel.Attachments)) {
                $scope.boxModel.Attachments = [];
            }
            attachmentService
                .uploadSelectedFiles(files, events, $scope.boxModel.Attachments)
                .then(function () {
                    $scope.pageIsDirty();
                });
        };

        // Delete attachment
        $scope.deleteAttachment = function (attachment) {
            attachmentService
                .delete(attachment.AttachmentExternalID)
                .then(function () {
                    var attachments = $scope.boxModel.Attachments;
                    _.remove(attachments, function (att) {
                        return att.AttachmentExternalID === attachment.AttachmentExternalID;
                    });
                });
        };

        function resetFollowUp() {
            $scope.boxModel = {};
            $scope.loading = false;
            $scope.pageIsNotDirty();
        }
    }
})();